import { useMatches } from '@frontend/weave-router';

export const useMatchUser = () => {
  const matches = useMatches();
  const user = matches.find((match) => match.id !== 'root')?.context.user;
  return user;
};
